import keymirror from 'keymirror'

export const ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  DEALS: '/discover',
  OVERVIEW: '/overview',
  DEPOSIT: '/overview/deposit',
  WITHDRAW: '/overview/withdraw',
  PORTFOLIO: '/portfolio',
  LIQUIDATE: '/portfolio/liquidate',
  FINANCIER: '/profile',
  FAQ: '/profile/faq',
  REPORTS: '/profile/reports',
}

export const LOGIN_DUCK = keymirror({
  EOL: null,
  LOGIN_INIT: null,
  LOGIN_FAILED: null,
  LOGIN_SUCCESS: null,
  REQUEST_OTP: null,
  RESEND_OTP: null,
  LOGIN_OTP: null,
})

export const REGISTER_DUCK = keymirror({
  ACCOUNT_TYPE: null,
  VALUES_CHANGE: null,
  DOC_CHANGE: null,
  UPLOADING_DOCS: null,
  UPLOADED_DOCS: null,
  AVAILABLE_PANS: null,
  FILE_UPLOAD: null,
  MESSAGE_CHANGE: null,
  REGISTER_STARTED: null,
  REGISTER_PENDING: null,
  REGISTER_SUCCESS: null,
  REGISTER_FAILURE: null,
})

export const DEALS_DUCK = keymirror({
  SEARCH: null,
})

export const PROFILE_DUCK = keymirror({
  FETCH_FINANCIER: null,
  FETCH_FINANCIER_SUCCESS: null,
  FETCH_FINANCIER_FAILURE: null,
  FETCH_WALLET_SUCCESS: null,
  NOMINEE_DETAILS: null,
  REFERRAL_DETAILS: null,
  FETCH_DEPOSIT_ACCOUNTS: null,
  UPDATE_BANK_VALUES: null,
  UPDATE_BANK_MESSAGES: null,
  GET_GST_INVOICES: null,
  MIS: null,
  EARNINGS_REPORT: null,
  OUTSTANDING_REPORT: null,
})

export const DOCUMENTS_DUCK = keymirror({
  ADD_EXTRACTED_DOC_IDS: null,
  SEARCH_DOC_ID: null,
  SEARCH_DOC_ID_PENDING: null,
  SEARCH_DOC_ID_SUCCESS: null,
  SEARCH_DOC_ID_FAILURE: null,
})

export const PORTFOLIO_DUCK = keymirror({
  SEARCH: null,
  FETCH_PORTFOLIO: null,
  FETCH_PORTFOLIO_SUCCESS: null,
  FETCH_PORTFOLIO_FAILURE: null,
  TAB_CHANGE: null,
  REPAID_TABLE: null,
})

export const OVERVIEW_DUCK = keymirror({
  FETCH_PORTFOLIO_TRACKERS: null,
  FETCH_PORTFOLIO_TRACKERS_SUCCESS: null,
  FETCH_PORTFOLIO_TRACKERS_FAILURE: null,
  FETCH_PENDING_WITHDRAWAL_REQUESTS: null,
  FETCH_PENDING_WITHDRAWAL_REQUESTS_SUCCESS: null,
  FETCH_PENDING_WITHDRAWAL_REQUESTS_FAILURE: null,
  CASHFREE_DEPOSIT: null,
  CASHFREE_WITHDRAW: null,
  CASHFREE_EOL: null,
})

export const REQUEST_STATUS = keymirror({
  IDLE: null,
  PENDING: null,
  SUCCESS: null,
  FAILURE: null,
})

export const DOCUMENT_URL_STATUS = keymirror({
  idle: null,
  pending: null,
  success: null,
  failure: null,
})

export const VALIDATION_STATUS = keymirror({
  IDLE: null,
  WARNING: null,
  SUCCESS: null,
  FAILURE: null,
})

export const REGISTRATION_STATUS = keymirror({
  REGISTRATION_IDLE: null,
  REGISTRATION_STARTED: null,
  REGISTRATION_PENDING: null,
  REGISTRATION_SUCCESS: null,
  REGISTRATION_FAILURE: null,
})

export const TOAST_STATE = keymirror({
  INFO: null,
  SUCCESS: null,
  WARNING: null,
  ERROR: null,
})

export const TOAST_DUCK = keymirror({
  EOL: null,
  SEND_TOAST: null,
})

export const COS_DUCK = keymirror({
  EOL: null,
  CREATE_DEAL_TRANSACTION: null,
  FETCH_SIGN_URL: null,
  VERIFY_DEAL_PURCHASE: null,
  REPAYMENTS_TABLE: null,
})

export const LIQUIDATION_DUCK = keymirror({
  EOL: null,
  CREATE_LIQUIDATION: null,
  SEND_OTP: null,
  RESEND_OTP: null,
  VERIFY_OTP: null,
})

export const BANNER_DUCK = keymirror({
  SHOW_BANNER: null,
  HIDE_BANNER: null,
})
